module.exports = __webpack_public_path__ + "static/pattern2-d38ea7237e62fa7746480d3744dd4540.png";